// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"f2ab436f","432":"a23398cd","640":"d9f725d5","655":"f5a4ebed"}[chunkId] + ".chunk.js";
};